
export default {
  delete: 'Delete',
  report: 'Report',
  guest: 'Please complete the registration process. You are a Guest member. Guest members can not use all features.',
  paymentCompleted: "Payment Completed",
  thankYou: "Thank You!",
  paymentSuccess: "Your payment has been successfully processed.",
  close: "Close",
  guest_form: {
    title: 'Please complete the registration process.',
    subtitle: 'When you complete the registration process, you will be able to use all features. After you complete the registration process, you will need to reconnect to the server.',
    new_username: 'New nickname',
    new_email: 'Email',
    password: 'Password',
    password_confirmation: 'Password confirmation',
    register: 'Complete registration',
    password_mismatch: 'Passwords do not match',
    username_length: 'Username must be at least 3 characters long.',
    email_invalid: 'Invalid email address.',
    password_length: 'Password must be at least 5 characters long.',
    invalid_username: 'Invalid username. @,.#+ are not allowed.',
    you_are_not_guest: 'You are not a guest member. Contact with support.',
    username_exist: 'Username already exists. Please choose another username.',
    try_again_later_or_contact_with_us: 'There is an error. Please try again. If the problem persists, please contact with support.',

  },
  sidebar: {
    channel: 'Channels',
    priv: 'Direct Messages',
    online: 'Online',
    away: 'Away',
    busy: 'Busy',
    change_avatar: ' Change Avatar',
    channel_list: 'Channel list',
    create_channel: 'Create Channel',
    close_window: 'Close',
    manage_channel: 'Manage Channel',
    part_channel: 'Leave Channel',
    delete_private_conversation: 'Delete PM',
    popular_users: 'Popular Users',
    conversations: 'Conversations',
    add_me: 'Add me',
    adminDashboard: 'Admin Dashboard',
    black_list: 'Black List',
    menu: 'Settings',
    no_conversations: 'Looking to strike up a conversation? <br /> You can start new messaging using Chatrooms, Matches, Live broadcasts and Reels.'
  },
  toolbar: {
    owner: 'Channel Owner:',
    search: 'Search',
  },
  chat: {
    download: 'Download file',
    image_blurred: 'Click to show image',
  },
  channel_settings: {
    title: 'Channel settings',
    general_settings: 'General settings',
    access_list: 'Access list',
    level_list: 'Level list',
    ban_list: 'Ban list',
    topic: 'Pinned Message',
    no_topic: 'This channel does not have a pinned message.',
    password: 'Password:',
    password_help: 'If a password is defined, users will be asked to enter the password when logging into the channel.',
    modes: {
      m: {
        title: 'Moderated',
        help: 'Only users with the power level of 1 or higher can sent messages.'
      },
      M: {
        title: 'Moderated Admin',
        help: 'Only users with the global access of 1 or higher can sent messages.'
      },
      u: {
        title: 'Sent Media',
        help: 'Only users with the power level of 1 or higher can sent media.'
      },
      U: {
        title: 'Sent Media Disabled',
        help: 'Nobody can sent media.'
      }
    }
  },
  buttons:{
    save: 'Save',
    cancel: 'Cancel',
    close: 'Close',
    delete: 'Delete',
    confirm: 'Confirm',
    message: 'Send message',
    gift: 'Send gift',
    edit: 'Edit',
    ok: 'OK',
    add: 'Add',
    color: 'Color',
  },

  password_change: {
    current: 'Current Password',
    new: 'New Password',
    confirm: 'Repeat New Password',
    change: 'Change Password',
  },
  settings: {
    edit_profile: 'Edit Info',
    edit: 'Edit',
    preview: 'Preview',
    h2: 'Settings',
    avatar_upload: 'Change Avatar',
    new_avatar: 'Load New Avatar',
    saveandclose: 'Save Avatar',
    zoom_in: 'Zoom In',
    zoom_out: 'Zoom Out',
    cancel: 'Cancel',
    avatar_label: 'Your avatar will be shown in the chat.',
    title: 'Account settings',
    profile: 'Profile Settings',
    security: 'Security Settings',
    theme: 'Theme',
    lists: {
      title: 'Lists',
      friends: 'Friend list',
      blocks: 'Blocks list'
    },
    about: 'About',
    about_placeholder: 'Tell me about yourself',
    gender: 'Gender',
    gender_placeholder: 'Select gender',
    location: 'Location',
    location_placeholder: 'Living location',
    age: 'Age',
    hobbies: 'Hobbies',
    hobbies_placeholder: 'Enter your hobbies',
    looking_for: 'Relationship Goal',
    lang_placeholder: 'Languages I Know',
    save: 'Save profile',
    zodiac: 'Zodiac',
    education: 'Education',
    genders: {
      male: 'Male',
      female: 'Female',
      other: 'Other'
    }
  },
  dialogs: {
    ban_dialogue:{
      title: 'Ban User',
      question: 'Do you want to kick from  #{channel}?',
      action: 'Action:',
      reason: 'Reason:',
      ban_n: 'Ban nickname',
      ban_i: 'Ban IP',
      ban_f: 'Ban fingerprint',
      ban_k: 'Kick',
      by: 'By:',
    },


    private_channel_title: 'Private channel',
    private_channel_subtitle: 'Enter channel key for join the channel',
    private_channel_okey: 'Join Channel',
    private_channel_cancel: 'Cancel',
    private_channel_label: 'Channel Key:',
    private_channel_warning: 'Please enter channel key',
    user_context_genders: {
      male: 'Male',
      female: 'Female',
      other: 'Other'
    },
    user_context_actions: {
      send_message: 'Send message',
      add_friend: 'Follow',
      remove_friend: 'Unfollow',
      block: 'Block user',
      unblock: 'Unblock user',
      kick: 'Kick user',
      kickServer: 'Global kick',
      showProfile: 'Open profile',
      sendGift: 'Send gift'
    }
  },
  filters: {
    filters: 'Filters',
    gender: 'Looking for',
    age: 'Age range',
    start: 'Start to matches',
    placeholder: 'Select Target Genders',
    placeholder2: 'Select Age Ranges',
  },
  matches: {
    no_matches: 'There are no more matches to show',
    like: 'Like',
    nope: 'Nope',
    message: 'Message',
    rewind: 'Rewind',
    later: 'Later',
  },
  profile_card: {
    about: 'About',
    age: 'years old.',
    hobbies: 'Hobbies',
    lookingFor: 'Looking for',
    langs: 'Languages I know',
    education: 'Education',
    sendGift: 'Gift',
    sendMessage: 'Send message',
  },
  login_register_form: {
    user_name_and_mail: 'User name or email',
    username: 'Username',
    password: 'Password',
    re_password: 'Repeat password',
    email: 'E-mail',
    register: 'Register',
    gender: 'Gender',
    login: 'Sign in',
    guest_login: 'Guest Login',
    forgot_password: 'Forgot password?',
    reset_password: 'Reset password',
    invalid_password: 'Password or username is incorrect.',
    username_exists: 'Username or mail already exists.',
    there_is_an_error: 'There is an error. Please try again.',
    no_mail: 'Don\'t use my email address',
  },
  error_messages: {
    info: 'Info',
    error: 'Error',
    "channel_not_found": {
      "message": "The requested channel could not be found."
    },
    "access_denied": {
      "message": "You do not have the required access level to perform this action."
    },

    "user_not_in_waiting_list": {
      "message": "The user is not in the waiting list."
    },
    
    "banned_from_channel": {
      "message": "You are banned from {channel} channel."
    },
    "incorrect_password": {
      "message": "The provided password is incorrect."
    },
    "exceed_max_channels": {
      "message": "You have reached the maximum number of channels you are allowed to join."
    },
    "join_event_error": {
      "message": "An error occurred while joining the channel."
    },
    "user_not_in_channel": {
      "message": "The user is not in the channel."
    },
    "blocked_from_private_message": {
      "message": "You are blocked from sending private messages to this user."
    },
    "no_valid_updates_found": {
      "message": "No valid updates were found."
    },
    "invalid_channel_data": {
      "message": "Invalid channel or data format."
    },
    "mode_update_error": {
      "message": "An error occurred while updating the channel modes."
    },
    "adding_ban_failed": {
      "message": "Failed to add a ban record."
    },
    "invalid_id": {
      "message": "Invalid ID provided."
    },
    "user_not_found": {
      "message": "User not found."
    },
    "invalid_conversation_id": {
      "message": "Invalid conversation ID."
    },
    "invalid_params": {
      "message": "Invalid parameters were provided."
    },
    "insufficient_privileges": {
      "message": "You do not have sufficient privileges to perform this action."
    },
    "already_following_or_user_not_found": {
      "message": "You are already following this user or the user does not exist."
    },
    "content_not_found": {
      "message": "The requested content could not be found."
    },
    "admin_level_protected": {
      "message": "The top-level admin access cannot be removed."
    },
    "length_limit_exceeded": {
      "message": "The title length exceeds the allowed limit."
    },
    "create_channel_failed": {
      "message": "Failed to create the channel."
    },
    "channel_name_exists": {
      "message": "A channel with the given name already exists."
    },
    "missing_message_data": {
      "message": "Missing message data."
    },
    "invalid_message_type": {
      "message": "The provided message type is invalid."
    },
    "image_upload_error": {
      "message": "An error occurred while uploading the image."
    },
    "unauthorized_access": {
      "message": "Unauthorized access."
    },
    "fetching_messages_error": {
      "message": "An error occurred while fetching messages."
    },
    "only_admin_can_send_messages": {
      "message": "Only channel admin can send messages to {channel}."
    },
    "only_global_admin_can_send_messages": {
      "message": "Only global admin can send messages to {channel}."
    },
    "only_admin_can_send_files": {
      "message": "Only admin can send files to {channel}."
    },
    "only_global_admin_can_send_files": {
      "message": "Only global admin can send files to {channel}."
    },
    "guest_members_can_not_send_messages": {
      "message": "Guest members can not send private messages. Please complete the registration process."
    },

  },
  load_credit_dialog: {
    buy_reels: 'You need to {amount} tokens to buy reels.',
    gift: 'You need to {amount} tokens to send a gift.',
    popular: 'You need to {amount} tokens to display on the popular list.',
    create_channel: 'You need to {amount} tokens to create a new channel.',
  },
  channel_error_messages: {
    1: 'Please fill all fields',
    2: 'This channel name is already exist',
    3: 'There is an error. Please try again. If the problem persists, please contact with support.',
  },
  langs: [
    {
      "id": "1",
      "name": "Afrikaans"
    },
    {
      "id": "2",
      "name": "Albanian"
    },
    {
      "id": "3",
      "name": "Amharic"
    },
    {
      "id": "4",
      "name": "Arabic",
      "match_group_key": "Arabic"
    },
    {
      "id": "5",
      "name": "Armenian",
      "match_group_key": "Armenian"
    },
    {
      "id": "133",
      "name": "ASL"
    },
    {
      "id": "6",
      "name": "Assamese"
    },
    {
      "id": "7",
      "name": "Aymara"
    },
    {
      "id": "8",
      "name": "Azerbaijani"
    },
    {
      "id": "9",
      "name": "Bambara"
    },
    {
      "id": "10",
      "name": "Basque"
    },
    {
      "id": "11",
      "name": "Belarusian"
    },
    {
      "id": "12",
      "name": "Bengali",
      "match_group_key": "Bengali"
    },
    {
      "id": "13",
      "name": "Bhojpuri"
    },
    {
      "id": "14",
      "name": "Bosnian"
    },
    {
      "id": "134",
      "name": "Breton"
    },
    {
      "id": "15",
      "name": "Bulgarian",
      "match_group_key": "Bulgarian"
    },
    {
      "id": "16",
      "name": "Burmese"
    },
    {
      "id": "17",
      "name": "Cantonese",
      "match_group_key": "Cantonese"
    },
    {
      "id": "18",
      "name": "Catalan"
    },
    {
      "id": "19",
      "name": "Cebuano"
    },
    {
      "id": "20",
      "name": "Chichewa"
    },
    {
      "id": "21",
      "name": "Corsican"
    },
    {
      "id": "22",
      "name": "Croatian"
    },
    {
      "id": "23",
      "name": "Czech",
      "match_group_key": "Czech"
    },
    {
      "id": "24",
      "name": "Danish",
      "match_group_key": "Danish"
    },
    {
      "id": "25",
      "name": "Dhivehi"
    },
    {
      "id": "26",
      "name": "Dogri"
    },
    {
      "id": "27",
      "name": "Dutch",
      "match_group_key": "Dutch"
    },
    {
      "id": "28",
      "name": "English",
      "match_group_key": "English"
    },
    {
      "id": "29",
      "name": "Esperanto"
    },
    {
      "id": "30",
      "name": "Estonian"
    },
    {
      "id": "31",
      "name": "Ewe"
    },
    {
      "id": "32",
      "name": "Filipino"
    },
    {
      "id": "33",
      "name": "Finnish",
      "match_group_key": "Finnish"
    },
    {
      "id": "34",
      "name": "French",
      "match_group_key": "French"
    },
    {
      "id": "35",
      "name": "Frisian"
    },
    {
      "id": "36",
      "name": "Galician"
    },
    {
      "id": "37",
      "name": "Georgian"
    },
    {
      "id": "38",
      "name": "German",
      "match_group_key": "German"
    },
    {
      "id": "39",
      "name": "Greek",
      "match_group_key": "Greek"
    },
    {
      "id": "40",
      "name": "Guarani"
    },
    {
      "id": "41",
      "name": "Gujarati",
      "match_group_key": "Gujarati"
    },
    {
      "id": "42",
      "name": "Haitian Creole"
    },
    {
      "id": "43",
      "name": "Hausa"
    },
    {
      "id": "44",
      "name": "Hawaiian"
    },
    {
      "id": "45",
      "name": "Hebrew",
      "match_group_key": "Hebrew"
    },
    {
      "id": "46",
      "name": "Hindi",
      "match_group_key": "Hindi"
    },
    {
      "id": "47",
      "name": "Hmong"
    },
    {
      "id": "48",
      "name": "Hungarian",
      "match_group_key": "Hungarian"
    },
    {
      "id": "49",
      "name": "Icelandic"
    },
    {
      "id": "50",
      "name": "Igbo"
    },
    {
      "id": "51",
      "name": "Ilocano"
    },
    {
      "id": "52",
      "name": "Indonesian",
      "match_group_key": "Indonesian"
    },
    {
      "id": "53",
      "name": "Irish",
      "match_group_key": "Irish"
    },
    {
      "id": "54",
      "name": "Italian",
      "match_group_key": "Italian"
    },
    {
      "id": "55",
      "name": "Japanese",
      "match_group_key": "Japanese"
    },
    {
      "id": "56",
      "name": "Javanese"
    },
    {
      "id": "57",
      "name": "Kannada"
    },
    {
      "id": "58",
      "name": "Kazakh"
    },
    {
      "id": "59",
      "name": "Khmer",
      "match_group_key": "Khmer"
    },
    {
      "id": "60",
      "name": "Kinyarwanda"
    },
    {
      "id": "61",
      "name": "Konkani"
    },
    {
      "id": "62",
      "name": "Korean",
      "match_group_key": "Korean"
    },
    {
      "id": "63",
      "name": "Krio"
    },
    {
      "id": "64",
      "name": "Kurdish"
    },
    {
      "id": "65",
      "name": "Kyrgyz"
    },
    {
      "id": "66",
      "name": "Lao"
    },
    {
      "id": "67",
      "name": "Latin"
    },
    {
      "id": "68",
      "name": "Latvian",
      "match_group_key": "Latvian"
    },
    {
      "id": "69",
      "name": "Lingala"
    },
    {
      "id": "70",
      "name": "Lithuanian",
      "match_group_key": "Lithuanian"
    },
    {
      "id": "71",
      "name": "Luganda"
    },
    {
      "id": "72",
      "name": "Luxembourgish"
    },
    {
      "id": "73",
      "name": "Macedonian"
    },
    {
      "id": "74",
      "name": "Maithili"
    },
    {
      "id": "75",
      "name": "Malagasy"
    },
    {
      "id": "76",
      "name": "Malay",
      "match_group_key": "Malay"
    },
    {
      "id": "77",
      "name": "Malayalam"
    },
    {
      "id": "78",
      "name": "Maltese"
    },
    {
      "id": "79",
      "name": "Mandarin Chinese",
      "match_group_key": "Chinese"
    },
    {
      "id": "80",
      "name": "Manipuri"
    },
    {
      "id": "81",
      "name": "Maori"
    },
    {
      "id": "82",
      "name": "Marathi"
    },
    {
      "id": "83",
      "name": "Mizo"
    },
    {
      "id": "84",
      "name": "Mongolian"
    },
    {
      "id": "85",
      "name": "Nepali"
    },
    {
      "id": "86",
      "name": "Norwegian",
      "match_group_key": "Norwegian"
    },
    {
      "id": "87",
      "name": "Odia"
    },
    {
      "id": "88",
      "name": "Oromo"
    },
    {
      "id": "89",
      "name": "Pashto"
    },
    {
      "id": "90",
      "name": "Persian",
      "match_group_key": "Persian"
    },
    {
      "id": "91",
      "name": "Polish",
      "match_group_key": "Polish"
    },
    {
      "id": "92",
      "name": "Portuguese",
      "match_group_key": "Portuguese"
    },
    {
      "id": "93",
      "name": "Punjabi",
      "match_group_key": "Punjabi"
    },
    {
      "id": "94",
      "name": "Quechua"
    },
    {
      "id": "95",
      "name": "Romanian",
      "match_group_key": "Romanian"
    },
    {
      "id": "96",
      "name": "Russian",
      "match_group_key": "Russian"
    },
    {
      "id": "97",
      "name": "Samoan"
    },
    {
      "id": "98",
      "name": "Sanskrit"
    },
    {
      "id": "99",
      "name": "Scots Gaelic"
    },
    {
      "id": "100",
      "name": "Sepedi"
    },
    {
      "id": "101",
      "name": "Serbian"
    },
    {
      "id": "102",
      "name": "Sesotho"
    },
    {
      "id": "103",
      "name": "Shona"
    },
    {
      "id": "104",
      "name": "Sindhi"
    },
    {
      "id": "105",
      "name": "Sinhala"
    },
    {
      "id": "106",
      "name": "Slovak",
      "match_group_key": "Slovak"
    },
    {
      "id": "107",
      "name": "Slovenian",
      "match_group_key": "Slovenian"
    },
    {
      "id": "108",
      "name": "Somali"
    },
    {
      "id": "109",
      "name": "Spanish",
      "match_group_key": "Spanish"
    },
    {
      "id": "110",
      "name": "Sundanese"
    },
    {
      "id": "111",
      "name": "Swahili",
      "match_group_key": "Swahili"
    },
    {
      "id": "112",
      "name": "Swedish",
      "match_group_key": "Swedish"
    },
    {
      "id": "113",
      "name": "Tajik"
    },
    {
      "id": "114",
      "name": "Tamil",
      "match_group_key": "Tamil"
    },
    {
      "id": "115",
      "name": "Tatar"
    },
    {
      "id": "116",
      "name": "Telugu"
    },
    {
      "id": "117",
      "name": "Thai",
      "match_group_key": "Thai"
    },
    {
      "id": "118",
      "name": "Tigrinya"
    },
    {
      "id": "119",
      "name": "Tsonga"
    },
    {
      "id": "120",
      "name": "Turkish",
      "match_group_key": "Turkish"
    },
    {
      "id": "121",
      "name": "Turkmen"
    },
    {
      "id": "122",
      "name": "Twi"
    },
    {
      "id": "123",
      "name": "Ukrainian",
      "match_group_key": "Ukranian"
    },
    {
      "id": "124",
      "name": "Urdu",
      "match_group_key": "Urdu"
    },
    {
      "id": "125",
      "name": "Uyghur"
    },
    {
      "id": "126",
      "name": "Uzbek"
    },
    {
      "id": "127",
      "name": "Vietnamese",
      "match_group_key": "Vietnamese"
    },
    {
      "id": "128",
      "name": "Welsh"
    },
    {
      "id": "129",
      "name": "Xhosa"
    },
    {
      "id": "130",
      "name": "Yiddish"
    },
    {
      "id": "131",
      "name": "Yoruba"
    },
    {
      "id": "132",
      "name": "Zulu"
    }
  ],
  genders: [
    { id: 2, name: 'Female' },
    { id: 1, name: 'Male' },
    { id: 3, name: "Agender" },
    { id: 4, name: "Androgyne" },
    { id: 5, name: "Androgynous" },
    { id: 6, name: "Bigender" },
    { id: 7, name: "FTM" },
    { id: 8, name: "FTW" },
    { id: 9, name: "Gender Fluid" },
    { id: 10, name: "Gender Questioning" },
    { id: 11, name: "Gender Variant" },
    { id: 12, name: "Genderqueer" },
    { id: 13, name: "Neither" },
    { id: 14, name: "Neutrois" },
    { id: 15, name: "Other" },
    { id: 16, name: "Pangender" },
    { id: 17, name: "Trans Person" },
    { id: 18, name: "Transfeminine" },
    { id: 19, name: "Transgender" },
    { id: 20, name: "Transgender Female" },
    { id: 21, name: "Transgender Male" },
    { id: 22, name: "Transgender Man" },
    { id: 23, name: "Transgender Person" },
    { id: 24, name: "Transgender Woman" },
    { id: 25, name: "Transmasculine" },
    { id: 26, name: "Two Spirit" }
  ],
  zodiac: [
    {
      "id": "1",
      "name": "Capricorn"
    },
    {
      "id": "2",
      "name": "Aquarius"
    },
    {
      "id": "3",
      "name": "Pisces"
    },
    {
      "id": "4",
      "name": "Aries"
    },
    {
      "id": "5",
      "name": "Taurus"
    },
    {
      "id": "6",
      "name": "Gemini"
    },
    {
      "id": "7",
      "name": "Cancer"
    },
    {
      "id": "8",
      "name": "Leo"
    },
    {
      "id": "9",
      "name": "Virgo"
    },
    {
      "id": "10",
      "name": "Libra"
    },
    {
      "id": "11",
      "name": "Scorpio"
    },
    {
      "id": "12",
      "name": "Sagittarius"
    }
  ],
  educations: [
    {
      "id": "1",
      "name": "Bachelors",
      "match_group_key": "Bachelors"
    },
    {
      "id": "2",
      "name": "In College"
    },
    {
      "id": "3",
      "name": "High School",
      "match_group_key": "Highschool"
    },
    {
      "id": "4",
      "name": "PhD",
      "match_group_key": "PhD"
    },
    {
      "id": "5",
      "name": "In Grad School"
    },
    {
      "id": "6",
      "name": "Masters",
      "match_group_key": "Masters"
    },
    {
      "id": "7",
      "name": "Trade School"
    },
    {
      "id": "8",
      "name": "Others",
    }
  ],
  lookingFor: [
    {
      "id": "1",
      "name": "Long-term partner",
      "style": "purple",
      "emoji": "💘",
    },
    {
      "id": "2",
      "name": "Long-term, open to short",
      "style": "pink",
      "emoji": "😍",
    },
    {
      "id": "3",
      "name": "Short-term, open to long",
      "style": "yellow",
      "emoji": "🥂",
    },
    {
      "id": "4",
      "name": "Short-term fun",
      "style": "green",
      "emoji": "🎉",
    },
    {
      "id": "5",
      "name": "New friends",
      "style": "turquoise",
      "emoji": "👋",
    },
    {
      "id": "6",
      "name": "Still figuring it out",
      "style": "blue",
      "emoji": "🤔",

    }
  ],
  diamond_dialogue: {
    title: "Start with Premium",
    h2: 'With Premium, you can instantly match with more people and gain unlimited usage features.',
    button: 'Get Premium',
    select_plan: 'Select a plan',
    continue: 'Continue',
  },
  call: {
    audio: 'Audio Call',
    video: 'Video Call',
    temp_list: 'Temporary List',
    waiting_list: 'Waiting List',
  },
  dockmenu: {
    matches: 'Matches',
    following: 'Following',
    reels: 'Reels',
    live: 'Live Streams',
    settings: 'Settings',
  },
  premium: {
    on: "Active",
    off: "OFF",
  },
  gifts: {
      send: "Send Gift",
      cancel: "Cancel",
  },
  posts: {
    manage: "Manage your posts",
    likes: "Like",
    views: "Views",
    created_at: "Created at",
    publish_post: "Publish the post",
    add: "Add",
    edit: "Edit",
  },
  reels: {
    report: 'Report this Reel',
    link: "Copy Reel Link",
    message: "Message",
    gift: "Gift",
    manage: "Manage your Reels",
    popular: "Popular Users",
    new: "Latest",
    trend: "Trending",
    top: "Top",
    no_reels: "There are no shared posts. You can share the first post and interact with new friends.",
    load_more: "Load more",

  },
  times: {
    seconds_ago: " seconds ago",
    minutes_ago: " minutes ago",
    hours_ago: " hours ago",
    days_ago: " days ago",
  },
  callMessages: {
    outgoingCallTitle: 'Calling {remoteUserName}...',
    outgoingCallWait: 'Please wait...',
    cancel: 'Cancel',
    incomingCallTitle: 'is calling you...',
    incomingCallMessage: 'You have an incoming call. Do you want to accept it?',
    accept: 'Accept',
    reject: 'Reject',
    callWithUser: 'Call with {remoteUserName}',
    endCall: 'End Call',
    callTimeoutTitle: 'Call Timeout',
    callTimeoutMessage: 'The call was not answered.',
    callRejectedTitle: 'Call Failed',
    callRejectedMessage: 'The call was rejected.',
    callRejectedUserBusy: 'The user is busy.',
    callRejectedNoPermission: 'The user did not grant media permissions.',
    callRejectedNoAnswer: 'No answer from the user.',
    callRejectedYouRejected: 'You rejected the incoming call.',
    callEndedTitle: 'Call Ended',
    callEndedMessage: 'The other party ended the call.',
    callCancelledTitle: 'Call Cancelled',
    callCancelledMessage: 'The other party cancelled the call.',
    accessDeniedTitle: 'Access Denied',
    accessDeniedMessage: 'You must grant access to your camera and microphone.',
    conversationNotFound: 'Conversation not found.',
  },
  notification: {
    giftReceived: 'Sent a gift <img class="gift-image" src="{image}"/> worth {gold} gold.',
    clear_all: 'Clear all',
    read_all: 'Read all',
    title: 'Notifications',
  },
  general_err: {
    blocked: 'You have blocked the user. Do you want to unblock and send message to this user?'
  },
  channelList: {
    title: 'Channels',
    name: 'Name',
    channelType: 'Type',
    owner: 'Owner',
    actions: 'Actions',
    join: 'Join',
    noChannels: 'No channels',
    public: 'Public',
    private: 'Private',
    protected: 'Protected',
    adult: 'Adult',
    adult_content_confirm: 'Are you sure you want to join this channel? This channel contains adult content.',
    i_am_18: 'I am 18+',
    confirmation: 'Confirmation',
    online_users: 'Online Users',
  },

  credits: {
    tokens: 'Tokens',
    per_token: 'per token',
    bonus: 'Bonus tokens',
    buy: 'Buy',
  },

  op_menu: {
    edit: 'Edit Profile',
    settings: 'Settings',
  },


  settings_panel: {
    myAccount: 'My Account',
    profilePicture: 'Profile Picture',
    editUserProfile: 'Edit User Profile',
    drag_drop: 'Drag and drop files to here to upload.',
    displayName: 'Display Name',
    email: 'Email',
    theme: 'Theme',
    premium: 'Premium',
    managePremium: 'Manage Premium',
    change: 'Change',
    off: 'OFF',
    success: 'Success',
    error: 'Error',
    rejected: 'Rejected',
    confirmation: 'Confirmation',
    cancel: 'Cancel',
    yesDeleteMyAccount: 'Yes, Delete my account',
    tokens: 'Tokens',
    loadTokens: 'Load Tokens',
    language: 'Language',

    // Privacy & Safety
    privacySafety: 'Privacy & Safety',
    privacySettings: 'Privacy Settings',
    clearPrivateMessages: 'Clear all private messages when reconnecting',
    doNotShowSpamMessages: 'Do not show me spam messages',
    showNSFWMessagesWithoutBlur: 'Show NSFW messages without blur',
    showBlockedUsersMessageInChannel: 'Show blocked users message in channel',

    // Notifications
    notifications: 'Display & Notifications',
    notificationSettings: 'Notification Settings',
    displaySettings: 'Display Settings',
    timestamp: 'Show timestamp in messages.',
    typing: 'Show typing list in channel.',
    reactions: 'Show reactions in messages.',

    soundAlertNewMessage: 'Sound alert on new message.',
    emailNotifications: 'Email Notifications',
    pushNotifications: 'Push Notifications',
    showTimestamp: 'Show timestamp in messages.',

    // Security
    security: 'Security',
    changePassword: 'Change Password',
    currentPassword: 'Current Password',
    newPassword: 'New Password',
    confirmNewPassword: 'Confirm New Password',
    deleteAccount: 'Delete Account',
    deleteAccountWarning: 'Warning: Deleting your account is irreversible. All your data will be permanently lost.',
    deleteAccountConfirmation: 'Are you sure you want to delete your account? This action cannot be undone.',
    passwordChanged: 'Password changed successfully',
    passwordChangeFailed: 'Failed to change password',
    currentPasswordTooShort: 'Current password is too short.',
    passwordTooShort: 'Password must be at least 8 characters long.',
    passwordsDoNotMatch: 'New passwords do not match.',
    accountDeletionRejected: 'You have rejected the account deletion.',

    // Blocked List
    blockedList: 'Blocked List',
    blockedUsers: 'Blocked Users',
    username: 'Username',
    actions: 'Actions',
    unblock: 'Unblock',
    noBlockedUsers: 'You have no blocked users.',

    // Billing
    billing: 'Billing',
    paymentHistory: 'Payment History',
    date: 'Date',
    amount: 'Amount',
    status: 'Status',
    noPaymentHistory: 'You have no payment history.',

    // Token History
    tokenHistory: 'Token History',
    tokenUsageHistory: 'Token Usage History',
    targetUsername: 'Target Username',
    tokensUsed: 'Tokens Used',
    action: 'Action',
    noTokenHistory: 'You have no token usage history.',

    // Token Actions
    sent: 'Sent',
    received: 'Received',
    loaded: 'Loaded',

    // Withdraw
    withdraw: 'Withdraw',
    withdrawTokens: 'Withdraw Tokens',
    submitWithdrawal: 'Submit Withdrawal',
    verifyIdentityMessage2: 'Your document(s) have been received. Waiting for review. You can upload additional documents if you wish.',
    verifyIdentityMessage: 'You need to verify your identity before withdrawing tokens.',
    verifyIdentity: 'Verify Identity',
    fillTheForm: 'Please fill the form with all information.',
    withdrawTokensInfo:'You have {tokens} tokens. You can withdraw {amount}.',
    withdrawAddress: 'Withdraw Address',
    withdrawMemo: 'Withdraw Memo',
    amountToWithdraw: 'How many tokens do you want to withdraw',
    minTokensForWithdraw: 'You need to have at least {amount} tokens to withdraw.',
    transactionHistory: 'Transaction History',
    table: {
      date: 'Date',
      used: 'Used Tokens',
      address: 'Address',
      memo: 'Memo',
      amount: 'Amount',
      status: 'Status',
    },
    withdrawSuccess: 'Withdrawal submitted successfully.',


    // Help Requests
    helpRequests: 'Help Requests',
    ticketList: 'Ticket List',
    noTickets: 'You have no tickets.',
    reply: 'Reply',

    // Support Ticket
    open: 'Open',
    closed: 'Closed',
    responded: 'Responded',

  },
  general_text: {
    noFollows: 'Your friends list is empty! Find new friends through, <a href="javascript:;" class="href_javascript">Matches</a>, <a href="javascript:;" class="href_javascript">Chatrooms</a>, or by joining Live broadcasts.',
  },
  supportTicket: {
    title: 'Create Support Ticket',
    subject: 'Subject',
    message: 'Message',
    submit: 'Submit',
    cancel: 'Cancel',
    selectSubject: 'Please select a subject.',
    sended: 'Your support ticket has been sent successfully.',
    topics: {
      technical: 'Technical Issue',
      billing: 'Billing Inquiry',
      general: 'General Question',
      aboutAccount: 'E-mail Change, Account Deletion, etc.',
      other: 'Other'
    }
  },
  popular_messages: {
    promotePhoto: "Put your photo in the foreground and make {names} and 3000+ girls see you in your area.",
    serviceCost: "Service cost <b>{cost}</b> token per {time} hour",
    exposureTime: "Your exposure time: {time}",
    title: "Instant Highlights!",
    addMe: "Add me"
  },
  create_channel: {
    createChannel: "Create Channel",
    channelName: "Channel Name",
    channelDescription: "Channel Description",
    enableAutojoin: "Enable Autojoin feature (Monthly fee for this feature is { cost } tokens.)",
    enableAutojoinFree: "Enable Autojoin feature ",
    adultContentChannel: "This channel contains adult content.",
    channelCreationCost: "When you create a channel, it will cost { cost } tokens.",
    info_message: "You can not create adult and autojoined channels at the same time.",
    nameTooShort: "Channel name is too short.",
    create: "Create"
  }
};
